import { Component } from 'preact'
import QuickLinkModal from './QuickLinkModal'
import Modal from '../../components/reactModal'
import { arrayMove, SortableContainer, SortableElement } from 'react-sortable-hoc'
import QuickLink from './QuickLink'
import QuickLinksList from './QuickLinksList'
import Hover from '../hover/Hover'
import EditOrDeleteQuickLink from './EditOrDeleteQuickLink'
import QuickLinksSettings from './QuickLinksSettings'

const SortableList = SortableContainer(({ children }) => children)
const SortableItem = SortableElement(({ children }) => children)

class QuickLinksManager extends Component {
  constructor (props) {
    super()
    this.state = {
      quickLinks: props.data,
      settings: props.settings,
      showModal: false,
      selectedItem: null,
      selectedIndex: null
    }
  }

  toggleModal (show = true, item = null, idx = null) {
    this.setState({ showModal: show, selectedItem: item, selectedIndex: idx })
  }

  deleteQuickLink (quickLink) {
    this.setState({
      quickLinks: this.state.quickLinks.filter(el => el !== quickLink)
    })
  }

  addQuickLink (quickLink) {
    const selectedIndex = this.state.selectedIndex
    let quickLinks = [].concat(this.state.quickLinks)

    if (selectedIndex !== null) {
      quickLinks.splice(selectedIndex, 1, quickLink)
    } else {
      quickLinks.push(quickLink)
    }

    this.setState({
      quickLinks: quickLinks,
      showModal: false
    })
  }

  componentWillUpdate (nextProps, nextState) {
    if (nextProps.onChange) {
      nextProps.onChange({ quickLinks: nextState.quickLinks, settings: nextState.settings })
    }
  }

  onSortEnd ({ oldIndex, newIndex }) {
    let quickLinks = [].concat(this.state.quickLinks)
    this.setState({ quickLinks: arrayMove(quickLinks, oldIndex, newIndex) })
  }

  render (props, state) {
    const quickLinks = state.quickLinks

    return <div className='quick-link-manager'>
      <QuickLinksSettings settings={state.settings} onChange={(settings) => this.setState({ settings: Object.assign({}, state.settings, settings) })} />
      <SortableList
        onSortEnd={(prev, next) => this.onSortEnd(prev, next)}
        axis='xy' >
        <QuickLinksList>
          {quickLinks.map((item, idx) =>
            <SortableItem index={idx} key={item.id} >
              <Hover hoverComponent={<EditOrDeleteQuickLink onDelete={() => this.deleteQuickLink(item)} onEdit={() => this.toggleModal(true, item, idx)} />}>
                <QuickLink item={item} enableBorder={state.settings.enableBorder} borderRadius={state.settings.borderRadius} isVisibleDesktop />
              </Hover>
            </SortableItem>
          )}
        </QuickLinksList>
      </SortableList>
      <hr />
      <div className={'add-quick-link text-center'}>
        <button className={'btn btn-primary'} onClick={() => this.toggleModal()}>
          <strong>Add quick link</strong>
        </button>
      </div>
      <Modal isOpen={state.showModal} onClose={() => this.toggleModal(false)}>
        <QuickLinkModal onSubmit={(quickLink) => this.addQuickLink(quickLink)} item={state.selectedItem} />
      </Modal>
    </div>
  }
}

export default QuickLinksManager
